var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDate, IsEnum, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { TreatmentPlanTaskViewDto } from '../../treatment-plan-detail/dto/treatment-plan-task-view.dto.js';
import { TreatmentPlanStatus } from '../../treatment-plan/enums/treatment-plan-status.enum.js';
export class ConceptSummaryDto {
    abbreviation;
    code;
    /** The prescribed Heilmittelkatalog option (GKV); null without one. Name it with `heilmittelLabel`. */
    optionName;
}
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ConceptSummaryDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ConceptSummaryDto.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ConceptSummaryDto.prototype, "optionName", void 0);
export class PerConceptProgressDto {
    abbreviation;
    code;
    /** The prescribed Heilmittelkatalog option (GKV); null without one. Name it with `heilmittelLabel`. */
    optionName;
    delivered;
    authorized;
}
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PerConceptProgressDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PerConceptProgressDto.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PerConceptProgressDto.prototype, "optionName", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PerConceptProgressDto.prototype, "delivered", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PerConceptProgressDto.prototype, "authorized", void 0);
export class TreatmentPlanPillDto {
    id;
    status;
    validUntil;
    conceptSummary;
    delivered;
    authorized;
    perConcept;
    tasks;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanPillDto.prototype, "id", void 0);
__decorate([
    IsEnum(TreatmentPlanStatus),
    Expose(),
    __metadata("design:type", String)
], TreatmentPlanPillDto.prototype, "status", void 0);
__decorate([
    IsDate(),
    Expose(),
    IsOptional(),
    Type(() => Date),
    __metadata("design:type", Object)
], TreatmentPlanPillDto.prototype, "validUntil", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => ConceptSummaryDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], TreatmentPlanPillDto.prototype, "conceptSummary", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentPlanPillDto.prototype, "delivered", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentPlanPillDto.prototype, "authorized", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => PerConceptProgressDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], TreatmentPlanPillDto.prototype, "perConcept", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => TreatmentPlanTaskViewDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], TreatmentPlanPillDto.prototype, "tasks", void 0);
//# sourceMappingURL=treatment-plan-pill.dto.js.map